<template>
  <div class="upload-medical-order-container">
    <InitialView
      @main-action="chooseFile()"
      @send-files="verifyProfessionalStep()"
      @secondary-action="openHasNoMedicalOrder()"
      @remove="(item) => removeFile(item)"
      :files="fileList"
      subtitle="Assim você agiliza seu atendimento"
    />
    <input
      type="file"
      name="file-chooser"
      id="file-chooser"
      ref="input"
      multiple
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import { InitialView } from './partials';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';
import professionalIdentificationStep from '@/utils/mixins/professionalIdentificationStep.mixin';

export default {
  components: {
    InitialView,
  },
  mixins: [professionalIdentificationStep, dataLayersMixin],
  created() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Adicione seus pedidos médicos',
    });
    this.checkAdmissionIdsOnMedicalOrders();
  },

  mounted() {
    this.fileList = this.getUploadedMedicalOrders;
  },

  data() {
    return {
      status: 'initial',
      fileList: [],
      showContinueWithoutAdvice: false,
      idPaperless: '',
      limitFiles: 10,
    };
  },

  computed: {
    ...mapState({
      admissionId: ({ currentAdmission }) => currentAdmission.data.id,
    }),
    ...mapGetters({
      getUploadedMedicalOrders: 'getUploadedMedicalOrders',
      hasMedicalOrdersSentToAnalyze: 'hasMedicalOrdersSentToAnalyze',
    }),
  },

  methods: {
    ...mapActions(['uploadFilesOnPaperless', 'checkAdmissionIdsOnMedicalOrders']),
    ...mapMutations([
      'SET_UPLOADED_MEDICAL_ORDERS',
      'SET_CLEAR_MEDICALORDERS',
      'SET_SEND_TO_ANALYZE',
    ]),
    chooseFile() {
      this.$refs.input.click();
    },
    verifyProfessionalStep() {
      this.enableProfessionalStep();
      this.goNextStep('exams_step');
    },

    async openHasNoMedicalOrder() {
      await this.$router.push({
        name: 'exams-list',
        params: { answer: 'Não tenho pedido médico' },
      });
    },
    removeFile(item) {
      this.fileList = this.fileList.filter((file) => file.data.documentUrl !== item);

      this.SET_UPLOADED_MEDICAL_ORDERS(this.fileList);
    },
    async handleFileChange({ target: { files = [] } }) {
      try {
        if (this.fileList.length < this.limitFiles) {
          for await (const file of files) {
            const fileObject = {
              file,
              status: 'UPLOADING',
              data: {
                status: 'UPLOADING',
                name: file.name,
              },
            };
            this.fileList = [...this.fileList, fileObject];
            this.SET_UPLOADED_MEDICAL_ORDERS(this.fileList);
            let uploadFile;
            try {
              uploadFile = await this.uploadFilesOnPaperless({ file });
            } catch (err) {
              console.error('Error to upload file to paperless! > ', err);
            }
            const findFile = this.fileList.find((item) => item === fileObject);
            if (uploadFile) {
              findFile.data = {
                ...findFile.data,
                ...uploadFile,
                status: 'UPLOADED',
                admissionId: this.admissionId,
              };
            }
            findFile.data.status = 'UPLOADED';
          }

          this.SET_UPLOADED_MEDICAL_ORDERS(this.fileList);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$refs.input.value = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-medical-order-container {
  flex: 1;
  padding: 0;
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  position: relative;
  overflow: hidden;

  input {
    display: none;
  }
}

.advice-before-leave {
  flex: 1;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  font-family: 'Dasa sans', sans-serif;

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h4 {
    font-size: 16px;
    line-height: 28px;
    color: #323232;
    font-weight: var(--font-weight-bold);
    margin-bottom: 8px;
  }

  p {
    font-size: 16px;
    line-height: 20.8px;
    color: #161616b8;
    padding: 0 17px;
    margin-bottom: 24px;
  }

  button {
    padding: 12px 0;
    text-align: center;
    background: #652cdf;
    border: 1px solid #652cdf;
    border-radius: 4px;
    color: white;
    font-size: 16px;
    line-height: 24px;
    font-weight: var(--font-weight-bold);
  }
}
</style>
